import { createFileRoute } from '@tanstack/react-router';
import { useLingui } from '@lingui/react/macro';
import { trpc } from '@/lib/trpc';
import { LegalPage } from './-components/legal-page';
import { slugs } from './legal-disclaimer.meta';

export const Route = createFileRoute('/www/legal-disclaimer')({
	loader: ({ context }) => {
		// `prefetchQuery`, not `ensureQueryData`: see the homepage loader.
		context.queryClient.prefetchQuery(
			trpc.core.getLegalContent.queryOptions({ type: 'legal-disclaimer', locale: context.locale }),
		);
	},
	component: Component,
});

function Component() {
	const { t } = useLingui();
	return (
		<LegalPage
			type="legal-disclaimer"
			slugs={slugs}
			title={t`Legal Notice - Worldcoo`}
			description={t`Legal Notice regulating the use of the service of the website owned by WORLDCOO S.L.`}
		/>
	);
}
